import React, { useEffect, useState } from "react";
import { useCheckMobileScreen } from "../card/card";
import "./menu.css";

const LINKS = [
 { id: "purpose", label: "Purpose" },
 { id: "services", label: "Services" },
 { id: "technologies", label: "Technologies" },
 { id: "contacts", label: "Contact" },
];

const scrollTo = (selectorId) => {
 const element = document.getElementById(selectorId);
 if (!element) return;
 const offsetPosition = element.getBoundingClientRect().top + window.scrollY - 90;
 window.scrollTo({ top: offsetPosition, behavior: "smooth" });
};

const AnvilMark = () => (
 <svg className="brand-mark" viewBox="0 0 64 64" aria-hidden="true">
  <defs>
   <linearGradient id="emberGrad" x1="0" y1="0" x2="1" y2="1">
    <stop offset="0%" stopColor="#ff220c" />
    <stop offset="55%" stopColor="#ff5c1f" />
    <stop offset="100%" stopColor="#ff8c3a" />
   </linearGradient>
  </defs>
  <path
   fill="url(#emberGrad)"
   d="M2 22c3 3 8 4 14 4h12c4 4 4 8 4 10h-6l-4 6v4h28v-4l-4-6h-6c0-2 0-6 4-10 6-2 10-4 14-6v-2H16c-4 0-11 0-14 4z"
  />
  <path fill="url(#emberGrad)" opacity="0.55" d="M22 6l4 8h-4l6 8-2-8h4l-8-8zM34 4l2 9h3l-1 7 5-9h-4l-5-7z" />
 </svg>
);

export function Menu() {
 const isSmallScreen = useCheckMobileScreen(900);
 const [scrolled, setScrolled] = useState(false);
 const [open, setOpen] = useState(false);
 const [active, setActive] = useState("");
 const progressRef = React.useRef(null);

 useEffect(() => {
  const onScroll = () => {
   setScrolled(window.scrollY > 24);

   let current = "";
   for (const link of LINKS) {
    const element = document.getElementById(link.id);
    if (element && element.getBoundingClientRect().top <= 160) {
     current = link.id;
    }
   }
   setActive(current);

   if (progressRef.current) {
    const total = document.documentElement.scrollHeight - window.innerHeight;
    const progress = total > 0 ? (window.scrollY / total) * 100 : 0;
    progressRef.current.style.width = `${progress}%`;
   }
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
 }, []);

 const navigate = (id) => {
  setOpen(false);
  scrollTo(id);
 };

 return (
  <header id="menu-container" className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
   <div className="navbar-inner">
    <button
     className="navbar-brand"
     onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
     aria-label="Back to top"
    >
     <AnvilMark />
     <span className="brand-name">
      Soft<span className="gradient-text">Forging</span>
     </span>
    </button>

    {isSmallScreen ? (
     <button
      className={`nav-burger ${open ? "is-open" : ""}`}
      onClick={() => setOpen(!open)}
      aria-label="Toggle menu"
     >
      <span />
      <span />
      <span />
     </button>
    ) : (
     <nav className="nav-links">
      {LINKS.map((link) => (
       <button
        key={link.id}
        className={`nav-link ${active === link.id ? "active" : ""}`}
        onClick={() => navigate(link.id)}
       >
        {link.label}
       </button>
      ))}
      <button className="nav-cta" onClick={() => navigate("contacts")}>
       Start a project
      </button>
     </nav>
    )}
   </div>
   <div className="nav-progress" ref={progressRef} aria-hidden="true"></div>

   {isSmallScreen && open && (
    <div className="nav-mobile-panel" onClick={() => setOpen(false)}>
     <nav className="nav-mobile-list" onClick={(e) => e.stopPropagation()}>
      {LINKS.map((link) => (
       <button
        key={link.id}
        className={`nav-link ${active === link.id ? "active" : ""}`}
        onClick={() => navigate(link.id)}
       >
        {link.label}
       </button>
      ))}
      <button className="nav-cta" onClick={() => navigate("contacts")}>
       Start a project
      </button>
     </nav>
    </div>
   )}
  </header>
 );
}
